// extracted by mini-css-extract-plugin
export default {"requiredCheckbox":"BudgetFieldScreen_requiredCheckbox__9xs-S","dragIconContainer":"BudgetFieldScreen_dragIconContainer__Zfg-N","dragIcon":"BudgetFieldScreen_dragIcon__DYNkb"};